export default __webpack_public_path__ + "static/media/login_2.1bd9e1e2.jpg";